

describe('WaitlistRegistrationSteps', () => {
  it('should not import WaitlistModal', () => {
    const fs = require('fs');
    const path = require('path');
    const filePath = path.join(__dirname, '../waitlist_registration_steps.js');
    const fileContent = fs.readFileSync(filePath, 'utf8');
    
    expect(fileContent).not.toContain('import WaitlistModal');
    expect(fileContent).not.toContain('from "./waitlist_modal"');
  });

  it('should not import PricePointSelectionForm', () => {
    const fs = require('fs');
    const path = require('path');
    const filePath = path.join(__dirname, '../waitlist_registration_steps.js');
    const fileContent = fs.readFileSync(filePath, 'utf8');
    
    expect(fileContent).not.toContain('import PricePointSelectionForm');
    expect(fileContent).not.toContain('from "./price_point_selection_form"');
  });

  it('should initialize pricePointId state with props.waitlist_price_point_id', () => {
    const fs = require('fs');
    const path = require('path');
    const filePath = path.join(__dirname, '../waitlist_registration_steps.js');
    const fileContent = fs.readFileSync(filePath, 'utf8');
    
    expect(fileContent).toContain('useState(props.waitlist_price_point_id)');
  });

  it('should preserve all custom registration flow types', () => {
    const fs = require('fs');
    const path = require('path');
    const filePath = path.join(__dirname, '../waitlist_registration_steps.js');
    const fileContent = fs.readFileSync(filePath, 'utf8');
    
    const customFlows = [
      'excite', 'sdsu', 'utep', 'utep-grass', 'utep-coach',
      'texas-state', 'wake-forest', 'sports-performance',
      'customized-data-collection', 'truncated-custom-reg-flow',
      'jmu-purple', 'prov-lax'
    ];

    customFlows.forEach(flow => {
      expect(fileContent).toContain(`"${flow}"`);
    });
  });

  it('should not contain case 0 references in flow functions', () => {
    const fs = require('fs');
    const path = require('path');
    const filePath = path.join(__dirname, '../waitlist_registration_steps.js');
    const fileContent = fs.readFileSync(filePath, 'utf8');
    
    const caseZeroMatches = fileContent.match(/case 0:/g);
    expect(caseZeroMatches).toBeNull();
  });

  it('should maintain dispatcher switch statement structure', () => {
    const fs = require('fs');
    const path = require('path');
    const filePath = path.join(__dirname, '../waitlist_registration_steps.js');
    const fileContent = fs.readFileSync(filePath, 'utf8');
    
    expect(fileContent).toContain('switch (props.custom_registration_type)');
    expect(fileContent).toContain('renderRegistrationFlow');
  });
});
